package com.milta.core.localization.translations.nl

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Mijn abonnement",
    screenSubtitle = "Beheer uw Milta-abonnement",
    planDriver = "Chauffeur",
    planOrganisation = "Bedrijf",
    statusActive = "Actief",
    statusTrial = "Proefperiode",
    statusExpired = "Verlopen",
    statusCancelled = "Geannuleerd",
    platformLabel = "Platform",
    productIdLabel = "Product",
    expiresAtLabel = "Vervalt op",
    noExpiry = "Geen vervaldatum",
    noValue = "—",
    noSubscription = "Geen actief abonnement",
    activateButton = "Abonnement activeren",
    successActivated = "Abonnement succesvol geactiveerd",
    perMonth = "/maand",
    pitchTitle = "Ontgrendel alle Milta-functies",
    pitchSubtitle = "Kies het abonnement dat past bij uw activiteit om te blijven leveren en uw ritten te beheren.",
    featuredBadge = "ALLES INCLUSIEF",
    driverFeature1 = "Onbeperkte ritten & leveringen",
    driverFeature2 = "Foto-bewijs van levering + handtekening",
    driverFeature3 = "Realtime meldingen",
    orgFeature1 = "Onbeperkt teambeheer",
    orgFeature2 = "Volledig webdashboard",
    orgFeature3 = "Ritten importeren (Excel, PDF, foto)",
    orgFeature4 = "Chauffeurstoegang voor uzelf inbegrepen",
    purchaseFinePrint = "Veilig betalen via de store. Op elk moment opzegbaar via de store-instellingen.",
    purchasingLabel = "Verwerken…",
    activeCaption = "Uw Milta-abonnement",
    nextRenewalLabel = "Volgende verlenging",
    includedTitle = "Inbegrepen in uw abonnement",
    manageOnGooglePlay = "Beheren op Google Play",
    manageOnAppStore = "Beheren op App Store",
    viewTechnicalDetails = "Technische details bekijken",
    monthNames = listOf("januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"),
    errorNotFound = "Geen actief abonnement gevonden",
    errorConflict = "Er bestaat al een actief abonnement voor dit account",
    errorPlanMismatch = "Het geselecteerde plan komt niet overeen met uw accountrol",
    errorPlanRequired = "Selecteer een plan",
    errorPlanInvalid = "Ongeldig plan geselecteerd",
    errorPlatformRequired = "Platform is vereist",
    errorPlatformInvalid = "Ongeldig platform. Moet AppStore of GooglePlay zijn",
    errorStoreProductIdRequired = "Store product-ID is vereist",
    errorReceiptTokenRequired = "Ontvangstbewijs token is vereist",
    errorGeneric = "Er is een fout opgetreden. Probeer opnieuw.",
    trialBannerDaysPrefix = "🎉 Gratis proefperiode: u heeft nog ",
    trialBannerDaysBold = "%d dagen",
    trialBannerDaysSuffix = " om Milta vrijblijvend te ontdekken.",
    trialBannerHoursPrefix = "⏰ Uw gratis proefperiode eindigt over ",
    trialBannerHoursBold = "%d u",
    trialBannerHoursSuffix = ": abonneer u om Milta zonder onderbreking te blijven gebruiken.",
    coveredByEnterprise = "Gedekt door het abonnement van uw onderneming",
    myEnterprisesTitle = "Mijn ondernemingen",
    enterpriseCoversYou = "Dekt u",
    enterpriseSubscriptionExpired = "Abonnement verlopen",
    myEnterprisesFootnote = "Uw ondernemingen optimaliseren de rondes die ze u sturen met hun eigen tegoed. U ziet hun verbruik niet.",
    takeDriverPlanForOwnUse = "Om uw eigen rondes te optimaliseren en zelf AI te gebruiken, neemt u een Chauffeur-abonnement.",
    ownPlanNotNeededWhenCovered = "U bent gedekt door uw onderneming, uw persoonlijk abonnement is niet nodig. Het dient voor de optimalisaties die u zelf start.",
)
